module.exports = __webpack_public_path__ + "img/full-logo.ffe6aff5.png";